import Parse from 'parse';
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import './App.css';


// Replace these with your actual Back4App keys
Parse.initialize("KA5YQnb4gvmVdWl71USCcS1h3P9pVvRUpFXIPBE5", "UXR26jfaq2q0pQdT5Iiy5fT6VY9O5x25ooKfsvBV");
Parse.serverURL = "https://parseapi.back4app.com/";


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
